import { defaultHttpClient } from '../../httpClient';

export interface GoodsAward {
  title: string;
  deeplink: string;
  description: string;
}

export interface GoodsAwardsResponse {
  awards: GoodsAward[];
}

export const getGoodsAwards = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsAwardsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/awards/`,
    })
    .then(result => result.data);
};
